import store from '@/store'

function install() {
    store.dispatch('initConfig')
}

export default {
    install,
}